import React from 'react';
import Box from '@nubank/nuds-web/components/Box/Box';
import Typography from '@nubank/nuds-web/components/Typography/Typography';

import { HeaderSection } from '../../styles/HeaderSection';

const Title = () => (
  <HeaderSection isHeader="true" backgroundColor="primary">
    <Box
      width="100%"
      maxWidth="1328px"
      tag="article"
    >
      <Box
        width="100%"
        tag="div"
        paddingHorizontal={{
          xs: '8x',
          md: '16x',
        }}
        paddingVertical={{
          md: '72px',
        }}
        flexDirection="column"
      >
        <Typography
          tag="h1"
          color="white"
          variant="heading1"
          intlKey="CREDIT_CARD_NU_CONTROL.CONDITIONS.HEAD.TITLE"
        />
      </Box>
    </Box>
  </HeaderSection>
);

export default Title;
